import { Card, Box, AppBar, Toolbar, Stack } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { CardHeader, ContainerHeader, BoxHeaderLogo, ButtonLogin } from './style'
import { ButtonLink } from '../../ui-kit'
import { routesGuest } from '../../../consts'
import { AppContainer } from '../../ui-kit/AppContainer'
import { IconLogo } from '../../../icons/IconLogo'
import { GuestHeaderLegalMenu } from './GuestHeaderLegalMenu'

export const GHeader = () => {
  return (
    <Card sx={CardHeader}>
      <AppContainer sx={ContainerHeader}>
        <AppBar position="static">
          <Toolbar>
            <Box sx={{ ...BoxHeaderLogo, flexGrow: 1 }}>
              <NavLink to={`../${routesGuest.ROOT.path}`}>
                <IconLogo />
              </NavLink>
            </Box>
            <Stack direction="row" alignItems="center" gap={1}>
              <ButtonLink to={`../${routesGuest.ROOT.path}`} variant="contained" color='primary' sx={ButtonLogin}>
                Войти
              </ButtonLink>
              <GuestHeaderLegalMenu />
            </Stack>
          </Toolbar>
        </AppBar>
      </AppContainer>
    </Card>
  )
}
